import { useState, useCallback, useEffect } from 'react'
import { toast } from 'react-toastify'
import validate from './validate'
import { get } from 'lodash'
import fetchCourseService from '../../services/api/fetch-course'
import useCurrentUser from '../use-current-user'
import createCourseService from '../../services/api/create-course'
import updateCourseService from '../../services/api/update-course'

const useExperience = (onComplete = () => {}, experienceId) => {
    const { currentUser } = useCurrentUser()
    const [ experience, setExperience ] = useState({
        date: new Date(),
        credits: 1,
        minCapacity: 4,
        maxCapacity: 10
    })
    const [ isBusy, setBusy ] = useState()
    const [ errors, setErrors ] = useState()

    useEffect(() => {
        let isSubscribed = true
        const effect = async () => {
            if(experienceId && currentUser) {
                setBusy(true)
                try {
                    const experience = await fetchCourseService(experienceId)
                    if (!isSubscribed) {
                        return
                    }
                    setExperience(experience)
                } catch (err) {
                    toast.error('There was an error retrieving the experience.')
                    console.error(`Unable to retrieve experience: ${experienceId}`, err)
                }
                setBusy(false)
            }
        }
        effect()
        return () => isSubscribed = false
    }, [experienceId, currentUser])

    const save = useCallback(async () => {
        let isSubscribed = true
        if (isBusy || !currentUser || !experience) { return }
        const errors = validate(experience)
        setErrors(errors)
        if (errors) { return }
        setBusy(true)
        try {
            if (experience.id) {
                await updateCourseService(experience)
                if (!isSubscribed) {
                    return
                }
                toast('Experience Updated!')
            } else {
                await createCourseService(experience)
                if (!isSubscribed) {
                    return
                }
                toast('Experience Created!')
            }
        } catch (err) {
            const message = get(err, 'response.data', 'An error creating the experience occurred.')
            toast.error(message)
            console.error('Error creating experience:', err)
        }
        setBusy(false)
        onComplete()
        return () => isSubscribed = false
    }, [isBusy, onComplete, currentUser, experience])

    return {
        isBusy,
        experience,
        save,
        setExperience,
        errors
    }
}

export default useExperience